// Página inicial da área Ferramentas: um cartão por ferramenta do catálogo.

import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Wrench } from 'lucide-react';
import { FERRAMENTAS } from './ferramentas';

const FerramentasHome: React.FC = () => (
  <div className="space-y-5 pb-24">
    <header>
      <h1 className="flex items-center gap-2 text-xl font-bold text-gray-900 dark:text-white">
        <Wrench size={22} className="text-primary" />
        Ferramentas
      </h1>
      <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">Utilitários para o dia a dia. Escolha uma ferramenta para começar.</p>
    </header>

    <ul className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {FERRAMENTAS.map(({ slug, titulo, descricao, icone: Icone }) => (
        <li key={slug}>
          <Link to={`/ferramentas/${slug}`}
            className="group flex h-full items-start gap-4 rounded-2xl border border-gray-200 bg-white p-5 transition-colors hover:border-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary dark:border-gray-700 dark:bg-gray-800/60">
            <div className="rounded-xl bg-primary/10 p-3 text-primary dark:bg-primary/20 dark:text-primary-light"><Icone size={22} /></div>
            <div className="min-w-0 flex-1">
              <h2 className="text-sm font-bold text-gray-900 dark:text-white">{titulo}</h2>
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{descricao}</p>
            </div>
            <ChevronRight size={18} className="mt-1 shrink-0 text-gray-300 transition-colors group-hover:text-primary" />
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default FerramentasHome;
